const COLOR_TRENDS_MODEL_OWNERSHIP = 'color trends 2026'
const COLOR_TRENDS_MATERIAL_BALL_TITLE = 'TIGER 2026趋势色彩与饰面'

function normalizeModelOwnership(modelOwnership) {
  return String(modelOwnership || '').trim().toLowerCase()
}

function isColorTrendsModelOwnership(modelOwnership) {
  return normalizeModelOwnership(modelOwnership) === COLOR_TRENDS_MODEL_OWNERSHIP
}

function filterColorTrendsViewers(viewers) {
  if (!Array.isArray(viewers)) {
    return []
  }

  return viewers.filter((viewer) =>
    isColorTrendsModelOwnership(viewer.modelOwnership)
  )
}

function sortColorTrendsViewers(viewers) {
  return filterColorTrendsViewers(viewers).slice().sort((a, b) => {
    const sortA = a.sort === undefined ? 0 : a.sort
    const sortB = b.sort === undefined ? 0 : b.sort
    if (sortA !== sortB) {
      return sortA - sortB
    }

    const industryA = String(a.industry || '').toLowerCase()
    const industryB = String(b.industry || '').toLowerCase()
    return industryA.localeCompare(industryB)
  })
}

function getColorTrendsMaterialBallViewer(viewers) {
  const sortedViewers = sortColorTrendsViewers(viewers)
  return sortedViewers.find((viewer) =>
    String(viewer.viewerTitle || '').trim() === COLOR_TRENDS_MATERIAL_BALL_TITLE
  ) || sortedViewers[0] || null
}

function getColorTrendsListViewers(viewers) {
  const sortedViewers = sortColorTrendsViewers(viewers)
  const materialBallViewer = getColorTrendsMaterialBallViewer(sortedViewers)
  return materialBallViewer
    ? sortedViewers.filter((viewer) => viewer.viewerId !== materialBallViewer.viewerId)
    : sortedViewers
}

function getColorTrendsMaterialImageKey(materialName) {
  const match = String(materialName || '').match(/\d{8}/)
  return match ? match[0] : ''
}

function groupColorTrendsMaterialImages(images) {
  if (!Array.isArray(images)) {
    return []
  }

  const groups = {}
  images.forEach((image) => {
    if (!image || !image.category) {
      return
    }
    if (!groups[image.category]) {
      groups[image.category] = []
    }
    groups[image.category].push(image)
  })

  return Object.keys(groups).map((name) => ({
    name,
    materials: groups[name]
  }))
}

function toggleColorTrendsCategoryState(expandedCategories, categoryName) {
  return expandedCategories && expandedCategories[categoryName]
    ? {}
    : { [categoryName]: true }
}

module.exports = {
  COLOR_TRENDS_MATERIAL_BALL_TITLE,
  COLOR_TRENDS_MODEL_OWNERSHIP,
  filterColorTrendsViewers,
  getColorTrendsMaterialBallViewer,
  getColorTrendsMaterialImageKey,
  groupColorTrendsMaterialImages,
  toggleColorTrendsCategoryState,
  getColorTrendsListViewers,
  isColorTrendsModelOwnership
}
